// extracted by mini-css-extract-plugin
var _1 = "useAICompose-module__animatedBackground--C8usn";
var _2 = "data-ai-compose";
export { _1 as "animatedBackground", _2 as "placeholderAttribute" }
